// noinspection JSNonASCIINames,NonAsciiCharacters

export const companySettingsTranslations = {
    company_settings: {
        tabs: {
            "General company data": {
                name: "Общая информация компании",
                tip: "Имя, логотип, и т.д."
            },
            "Company registration data": {
                name: "Регистрационные данные компании",
                tip: "Рег. номер, адрес.."
            },
            "Invoice details": {
                name: "Данные инвойса",
                tip: "Данные, показанные в счетах на продажу"
            }
        },
        general: {
            name: "Имя компании",
            name_error: "Пожалуйста, заполните имя компании",
            logo: "Логотип",
            no_logo: "Логотип не установлен"
        },
        reg_data: {
            reg_code: "Рег. код",
            reg_code_error: "Пожалуйста, заполните регистрационный код",
            vat_number: "НДС номер",
            legal_address: "Юридический адрес",
            city: "Город",
            post_code: "Почтовый код",
            country: "Страна",
            country_error: "Пожалуйста, укажите страну регистрации",
            email: "Эл. почта",
            email_error: "Не правильный адрес эл. почты",
            phone_num: "Телефон",
        },
        invoice: {
            header_address: "Адрес",
            use_legal_address: "Использовать юридический адрес",
            invoice_address: "Адрес на инвойсе",
            city: "Город",
            post_code: "Почтовый код",
            country: "Страна",
            country_error: "Пожалуйста, укажите страну на инвойсе",
            email: "Эл. почта",
            email_error: "Не правильный адрес эл. почты",
            phone_num: "Телефон",


            header_banks: "Банки",
            account_error: "Пожалуйста, выберите счет",
            bank_detail: "Данные банка",
            bank_detail_error: "Пожалуйста, укажите данные банка",
            additional_bank_detail: "Доп. данные банка",
        }
    }
}